import http from 'utils/http';
import {
  getActivateBusinessAddonUrl,
  getBusinessAddonsUrl,
  getCancelBusinessAddonUrl,
  getReverseBusinessAddonCancellationUrl
} from './apiUrls';
import { ActivateBusinessAddonResponse, CancelBusinessAddonPayload, CancelBusinessAddonResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getBusinessAddons(params?: Record<string, unknown>): Promise<{
  data: import('./types').BusinessAddon[];
  meta?: MetaApiResponse;
}> {
  return http.get(getBusinessAddonsUrl(), params);
}

export function activateBusinessAddon(code: string): Promise<ActivateBusinessAddonResponse> {
  return http.post(getActivateBusinessAddonUrl(code));
}

export function cancelBusinessAddon(
  code: string,
  payload: CancelBusinessAddonPayload
): Promise<CancelBusinessAddonResponse> {
  return http.post(getCancelBusinessAddonUrl(code), payload);
}

export function reverseBusinessAddonCancellation(code: string): Promise<CancelBusinessAddonResponse> {
  return http.post(getReverseBusinessAddonCancellationUrl(code));
}
